import u from 'updeep';
import { handleActions } from 'redux-actions';
import * as actions from './offlineBooksActions';
import { openOfflineTranslator } from './bookActions';

const initialState = {
  books: [],
  isSavingOffline: false,
  isSavingBookSlugs: [],
  activeTabIndex: 0,
  isSavingOfflineTranslations: false,
  translations: [],
  isSavingTranslateBookSlugs: [],
  coachmarkSeenCount: [],
  isUpdatingRPBooks: false
};

export default handleActions({
  [actions.saveOffline]: (state, action) => u({
    isSavingOffline: true,
    isSavingBookSlugs: state.isSavingBookSlugs.concat(action.payload.book.slug)
  }, state),

  [actions.receiveSaveOffline]: (state, action) => {
    let books = ([]).concat(state.books);

    books.forEach(el => {
      if(el.isFromStemHome && el.lpData && el.lpData.attributes && el.lpData.attributes && el.lpData.attributes.localizations) {
        el.lpData.attributes.localizations = {data: []}
      }
    })

    let book = books.find(book => !book.isFromOfflineTranslate && !book.isFromReadingProgram && !book.isFromFlpHome && !book.isFromStemHome && book.id === action.payload.book.id);
    let bookIdx = books.findIndex(book => !book.isFromOfflineTranslate && !book.isFromReadingProgram && !book.isFromFlpHome && !book.isFromStemHome && book.id === action.payload.book.id);

    if (action.payload.book.isFromReadingProgram) {
      book = books.find(book => book.isFromReadingProgram && book.id === action.payload.book.id);
      bookIdx = books.findIndex(book => book.isFromReadingProgram && book.id === action.payload.book.id);
    }

    if (action.payload.book.isFromFlpHome) {
      book = books.find(book => book.isFromFlpHome && book.id === action.payload.book.id);
      bookIdx = books.findIndex(book => book.isFromFlpHome && book.id === action.payload.book.id);
    }

    if (action.payload.book.isFromStemHome) {
      book = books.find(book => book.isFromStemHome && book.id === action.payload.book.id && book.lpId === action.payload.book.lpId);
    }
    
    if(!book) {
      book = Object.assign({}, action.payload.book)
      books.push(book);
    }
    else if(bookIdx >= 0) { //override the new data
      books[bookIdx] = Object.assign(book, action.payload.book)
    }

    if(!book.savedUsers){
      book.savedUsers = [];
      book.enrolledUsers = [];
    } 

    if(!book.savedUsers.includes(action.payload.userId)){
      book.savedUsers.push(action.payload.userId);
      book.enrolledUsers.push(action.payload.book[action.payload.userId]);
    } 
    
    return u({
      books: books,
      isSavingOffline: false,
      isSavingBookSlugs: u.reject(slug => {
        return action.payload.book.slug === slug
      })
    }, state);
  },

  [actions.saveOfflineError]: (state, action) => u({
    isSavingOffline: false,
    // TODO: add slug in action's payload and remove only failing slugs
    isSavingBookSlugs: []
  }, state),

  [actions.unsaveOffline]: (state, action) => {
    let books = ([]).concat(state.books);
    const userId = action.payload.userId;
    
    let book = books.find(book => !book.isFromOfflineTranslate && !book.isFromReadingProgram && !book.isFromFlpHome && !book.isFromStemHome && book.id === action.payload.book.id);
    if(action.payload.book.isFromReadingProgram){
      book = books.find(book => book.isFromReadingProgram && book.id === action.payload.book.id);
    }

    if (action.payload.book.isFromFlpHome) {
      book = books.find(book => book.isFromFlpHome && book.id === action.payload.book.id);
    }
    
    if (action.payload.book.isFromStemHome) {
      book = books.find(book => book.isFromStemHome && book.id === action.payload.book.id && book.lpId === action.payload.book.lpId);
    }
    
    if(book && book.savedUsers && (book.savedUsers.length > 1) && (book.savedUsers.includes(userId))) {
      book.savedUsers.splice(book.savedUsers.indexOf(userId), 1);
    }
    else {
      books.splice(books.indexOf(book), 1);
    }

    return u({
      books: books,
    }, state);
  },

  [actions.onTabChange]: (state, action)=> u({
    activeTabIndex: action.payload ? action.payload.activeTabIndex : 0
  }, state),

  [actions.saveOfflineTranslations]: (state, action) => u({
    isSavingOfflineTranslations: true,
    isSavingTranslateBookSlugs: state.isSavingTranslateBookSlugs.concat(action.payload.book.slug)
  }, state),

  [actions.receiveSaveOfflineTranslations]: (state, action) => {
    let books = ([]).concat(state.books);
    let offlineBook = books.find(book => book.isFromOfflineTranslate && book.id === action.payload.book.id);
    let translations = ([]).concat(state.translations);
    const userId = action.payload.userId;
    const targetLanguage = action.payload.translationContent.targetLanguage;
    
    let translation = translations.find(translation => translation.id === action.payload.book.id && translation.userId === userId && translation.targetLanguage === targetLanguage);

    if(!offlineBook) {
      offlineBook = Object.assign({}, action.payload.book)
      books.push(offlineBook);
    };

    if(!offlineBook.savedUsers) offlineBook.savedUsers = [];

    if(!offlineBook.savedUsers.includes(userId)) offlineBook.savedUsers.push(userId); 

    if(!translation) {
      translation = Object.assign ({}, action.payload.book, { userId, targetLanguage });
      translations.push(translation);
    }

    return u({
      books: books,
      translations: translations,
      isSavingOfflineTranslations: false,
      isSavingTranslateBookSlugs: u.reject(slug => {
        return action.payload.book.slug === slug
      }),
    }, state)
  },

  [actions.saveOfflineTranslationsError]: (state, action) => u({
    saveError: action.payload,
    isSavingOfflineTranslations: false,
    isSavingTranslateBookSlugs: []
  }, state),

  [actions.updateOfflineTranslations]: (state, action) => u({
    isSavingOfflineTranslations: true,
  }, state),

  [actions.receiveUpdateOfflineTranslations]: (state, action) => {
    let translations = ([]).concat(state.translations);
    const targetLanguage = action.payload.translationContent.targetLanguage;
    
    let translation = translations.find(translation => translation.id === action.payload.book.id && translation.userId === action.payload.userId && translation.targetLanguage === targetLanguage);
    translation.lastEdited = action.payload.book.lastEdited ? action.payload.book.lastEdited : '';

    return u({
      translations: translations,
      isSavingOfflineTranslations: false,
    }, state)
  },

  [actions.updateOfflineTranslationsError]: (state, action) => u({
    isSavingOfflineTranslations: false,
  }, state),

  [actions.unsaveOfflineTranslations]: (state, action) => {
    let books = ([]).concat(state.books);
    let offlineBook = books.find(book => book.isFromOfflineTranslate && book.id === action.payload.book.id);
    const userId = action.payload.userId;
    let translations = ([]).concat(state.translations);
    const bookTranslations = translations.filter(translation => translation.id === action.payload.book.id) 
    let translation = bookTranslations.find(translation => translation.userId === userId && translation.targetLanguage === action.payload.book.targetLanguage);
    
    if(translation) translations.splice(translations.indexOf(translation), 1);

    if(offlineBook && offlineBook.savedUsers && (offlineBook.savedUsers.length > 1) && offlineBook.savedUsers.includes(userId)) {
      offlineBook.savedUsers.splice(offlineBook.savedUsers.indexOf(userId), 1);
    }
      
    // delete book if there are no translations
    if (bookTranslations.length <= 1) books.splice(books.indexOf(offlineBook), 1);

    return u({
      books: books,
      translations: translations
    }, state);
  },

  [openOfflineTranslator]: (state, action) => {
    let users = ([]).concat(state.coachmarkSeenCount);
    let user = users.find(us => us.userId === action.payload.userId );
    let index = users.indexOf(user);

    if(index < 0){
      users.push({"userId": action.payload.userId, "count": 1})
    }
    else{
      users[index].count = user.count + 1;
    }

    return u({
      coachmarkSeenCount: users,
    }, state)
  },

  [actions.updateTheme]: (state, action) => u({
    isUpdatingRPBooks: true
  }, state),

  [actions.receiveTheme]: (state, action) => {
    let books = ([]).concat(state.books);
    let book = books.find(book => book.isFromReadingProgram && book.id === action.payload.book.id);
    const themeData = action.payload.data;

    book.fluencyId = themeData.fluenceId.toString();
    book.themeNumber = book.enrolledUsers[0].themeNumber;
    book.themeDescription = themeData.description;
    book.themeTip = themeData.tip;
    book.themeImage = themeData.themeImage;
    book.themeMobileImage = themeData.themeMobileImage;
    book.themeName = themeData.themeName;

    return u({
      books: books,
      isUpdatingRPBooks: false,
    }, state)
  }

}, initialState);



// WEBPACK FOOTER //
// ./src/redux/offlineBooksReducer.js